import React, { useEffect, useState } from 'react';
import { Grid, TextField, Button, IconButton, Typography, Box, Card, CircularProgress } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import { DatePicker } from '@react-shamsi/datepicker';
import moment from 'moment-jalaali';
import axios from './../../../axios/api';
import toast from 'react-hot-toast';
import { PREFIX_URL } from '../../../components/Constants';
import "./../styleDatePicker.css";

// If you want to use the time picker
const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const FormBanner = ({ isEdit = false, refreshData, idEdit = null, handleCloseModal, DataEdit }) => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [imageName, setImageName] = useState('');
    const [Title, setTitle] = useState('');
    const [LinkAdv, setLinkAdv] = useState('');
    const [fromDate, setFromDate] = useState(null);
    const [maxDate, setMaxDate] = useState(null);
    const [errors, setErrors] = useState({ title: '', path: '', link: '', from_date: '', to_date: '' });
    const [LoadingButton, setLoadingButton] = useState(false);



    useEffect(() => {
        if (errors.to_date) {
            setErrors((prevErrors) => ({ ...prevErrors, to_date: '' }));
        }
    }, [maxDate])

    useEffect(() => {
        if (errors.from_date) {
            setErrors((prevErrors) => ({ ...prevErrors, from_date: '' }));
        }
    }, [fromDate])

    useEffect(() => {
        if (isEdit) {
            setTitle(DataEdit?.title);
            setLinkAdv(DataEdit?.link);
            if (DataEdit?.path) {
                setSelectedImage(checkAndAddPrefix(DataEdit?.path));
                setImageName("Edit");

            }
            if (DataEdit?.to_date) {
                const jalaliDate = DataEdit?.to_date;
                const gregorianDate = moment(jalaliDate, 'jYYYY/jMM/jDD').toDate();
                console.log("formattedDate: " + gregorianDate);
                setMaxDate(gregorianDate);
            }
            if (DataEdit?.from_date) {
                const jalaliDate = DataEdit?.from_date;
                const gregorianDate = moment(jalaliDate, 'jYYYY/jMM/jDD').toDate();
                console.log("formattedDate: " + gregorianDate);
                setFromDate(gregorianDate);
            }
        }
    }, [isEdit]);

    const checkAndAddPrefix = (url) => {
        const prefix = PREFIX_URL;
        if (url && url.startsWith('/uploads/')) {
            return `${prefix}${url}`;
        }
        return url;
    };

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedImage(file);
            setImageName(file.name);

            // Convert selected image to base64
            const reader = new FileReader();
            reader.onloadend = () => {
            };
            reader.readAsDataURL(file);
        }
        if (errors.path) {
            setErrors((prevErrors) => ({ ...prevErrors, path: '' }));
        }
    };

    const reseteState = () => {
        setImageName('');
        setTitle('');
        setLinkAdv('');
        setMaxDate(null);
        setFromDate(null);
        setSelectedImage(null);
    }

    const handleRemoveImage = () => {
        setSelectedImage(null);
        setImageName('');
    };

    const handleTitleChange = (event) => {
        setTitle(event.target.value);
        if (errors.title) {
            setErrors((prevErrors) => ({ ...prevErrors, title: '' }));
        }
    };

    const handleLinkAdvChange = (event) => {
        setLinkAdv(event.target.value);
        if (errors.link) {
            setErrors((prevErrors) => ({ ...prevErrors, link: '' }));
        }
    };


    const UpdateBanner = async () => {
        try {

            const formData = new FormData();
            // Append the data to the FormData object
            formData.append('title', Title);
            formData.append('link', LinkAdv);
            formData.append('type', "slider");
            if (selectedImage && imageName != "Edit") {
                formData.append('path', selectedImage);
            }
            if (fromDate) {
                formData.append('from_date', changeFormatDate(fromDate));
            }
            if (maxDate) {
                formData.append('to_date', changeFormatDate(maxDate));
            }
            setLoadingButton(true);
            const res = await axios.post(`/admin/ad/update/${idEdit}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            });

            toast.success(res.data?.message);
            reseteState();
            refreshData();
            handleCloseModal();
        } catch (error) {
            if (error.response?.status === 422) {
                setErrors({
                    title: error.response.data.data.title ? error.response.data.data.title[0] : '',
                    path: error.response.data.data.path ? error.response.data.data.path[0] : '',
                    link: error.response.data.data.link ? error.response.data.data.link[0] : '',
                    from_date: error.response.data.data.from_date ? error.response.data.data.from_date[0] : '',
                    to_date: error.response.data.data.to_date ? error.response.data.data.to_date[0] : '',

                });
            } else {
                toast.error(error.response?.data?.message || 'An error occurred');
            }
        } finally {
            setLoadingButton(false);
        }
    };


    const sendBanner = async () => {
        try {
            const formData = new FormData();
            // Append the data to the FormData object
            formData.append('title', Title);
            formData.append('link', LinkAdv);
            formData.append('type', "slider");
            if (fromDate) {
                formData.append('from_date', changeFormatDate(fromDate));
            }
            if (maxDate) {
                formData.append('to_date', changeFormatDate(maxDate));
            }

            if (selectedImage) {
                formData.append('path', selectedImage);
            }

            setLoadingButton(true);
            const res = await axios.post('/admin/ad/store', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            });

            toast.success(res.data?.message);
            reseteState();

        } catch (error) {
            toast.error(error.response?.data?.message || 'An error occurred');

            if (error.response?.status === 422) {
                setErrors({
                    title: error.response.data.data.title ? error.response.data.data.title[0] : '',
                    path: error.response.data.data.path ? error.response.data.data.path[0] : '',
                    link: error.response.data.data.link ? error.response.data.data.link[0] : '',
                    from_date: error.response.data.data.from_date ? error.response.data.data.from_date[0] : '',
                    to_date: error.response.data.data.to_date ? error.response.data.data.to_date[0] : '',

                });
            }
        } finally {
            setLoadingButton(false);
        }
    };

    const isBlobOrFile = (obj) => {
        return obj instanceof Blob || obj instanceof File;
    };

    const persianToEnglishNumbers = (persianNumber) => {
        const persianDigits = '۰۱۲۳۴۵۶۷۸۹';
        const englishDigits = '0123456789';
        return persianNumber.split('').map(char => {
            const index = persianDigits.indexOf(char);
            return index !== -1 ? englishDigits[index] : char;
        }).join('');
    };

    const changeFormatDate = (newDate) => {
        const persianDate = moment(newDate).format('jYYYY/jMM/jDD');
        return persianToEnglishNumbers(persianDate);
    };

    return (
        <div dir="rtl">
            <Card variant="outlined" sx={{ margin: 0, width: '100%' }}>
                <Grid container spacing={2}>
                    <Grid item lg={6} md={6} sm={12} sx={{ margin: 0, width: '100%' }}>
                        <TextField
                            id="title"
                            label="عنوان اسلایدر"
                            type="text"
                            variant="outlined"
                            placeholder='عنوان اسلایدر را وارد کنید'
                            fullWidth
                            value={Title}
                            onChange={handleTitleChange}
                            error={Boolean(errors.title)}
                            helperText={errors.title}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} sx={{ margin: 0, width: '100%' }}>
                        <TextField
                            id="LinkAdv"
                            label="لینک تبلیغاتی"
                            type="text"
                            variant="outlined"
                            placeholder='... https://google.com/'
                            fullWidth
                            value={LinkAdv}
                            onChange={handleLinkAdvChange}
                            error={Boolean(errors.link)}
                            helperText={errors.link}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} sx={{ zIndex: 99999999999, width: '100%' }} >
                        <Typography variant='body2'>تاریخ شروع</Typography>
                        <DatePicker
                            placeholder='تاریخ اعتبار را وارد کنید'
                            style={{ zIndex: 99999, fontFamily: 'IranSans', width: '100%', padding: 15 }}
                            autoUpdate
                            date={fromDate}
                            onChange={setFromDate}

                        />
                        {errors.from_date && (
                            <Typography variant="caption" color="error">
                                {errors.from_date}
                            </Typography>
                        )}
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} sx={{ zIndex: 9999999999, width: '100%' }} >
                        <Typography variant='body2'>تاریخ اعتبار</Typography>
                        <DatePicker
                            placeholder='تاریخ اعتبار را وارد کنید'
                            style={{ zIndex: 99999, fontFamily: 'IranSans', width: '100%', padding: 15 }}
                            autoUpdate
                            date={maxDate}
                            min={fromDate}
                            onChange={setMaxDate}
                        />
                        {errors.to_date && (
                            <Typography variant="caption" color="error">
                                {errors.to_date}
                            </Typography>
                        )}
                    </Grid>
                    {selectedImage && (
                        <Grid item lg={12} md={12} sm={12}>
                            <Box sx={{
                                position: 'relative',
                                display: 'inline-block',
                                border: '1px dashed #ccc',
                                padding: 1,
                                borderRadius: 2
                            }}>
                                <img
                                    src={isBlobOrFile(selectedImage) ? URL.createObjectURL(selectedImage) : selectedImage}
                                    alt="Selected Image"
                                    style={{ width: 100, height: 100, borderRadius: 10 }}
                                />
                                <IconButton
                                    onClick={handleRemoveImage}
                                    aria-label="Remove Image"
                                    size="small"
                                    sx={{
                                        width: 20,
                                        height: 20,
                                        position: 'absolute',
                                        top: -5,
                                        right: -7,
                                        backgroundColor: '#EC2327',
                                        color: 'white',
                                        '&:hover': {
                                            opacity: 1,
                                        },
                                    }}
                                >
                                    <CloseIcon sx={{ width: 10, height: 10 }} color="black" fontSize="small" />
                                </IconButton>
                                <br />
                                <Typography variant="caption" sx={{ mt: 1 }}>
                                    {imageName}
                                </Typography>
                            </Box>
                        </Grid>
                    )}
                    <Grid item lg={12} md={12} sm={12}>
                        <Button
                            component="label"
                            role={undefined}
                            variant="contained"
                            tabIndex={-1}
                            startIcon={<CloudUploadIcon />}
                        >
                            <Typography variant="caption">آپلود تصویر</Typography>
                            <VisuallyHiddenInput type="file" accept="image/*" onChange={handleImageChange} />

                        </Button>
                        {errors.path && (
                            <Typography variant="caption" color="error">
                                {errors.path}
                            </Typography>
                        )}
                    </Grid>
                    <Grid item lg={12} md={12} sm={12}>
                        {isEdit ?
                            <Button color="secondary" fullWidth variant="contained" size="large"
                                onClick={UpdateBanner}
                                disabled={LoadingButton}>
                                {LoadingButton && <CircularProgress size={24} color="inherit" />}

                                <Typography color="white">ویرایش اسلایدر </Typography>
                            </Button>
                            :
                            <Button
                                color="secondary"
                                fullWidth
                                variant="contained"
                                size="large"
                                onClick={sendBanner}
                                disabled={LoadingButton}>
                                {LoadingButton && <CircularProgress size={24} color="inherit" />}

                                <Typography color="white">ثبت اسلایدر جدید</Typography>
                            </Button>
                        }
                    </Grid>

                </Grid>
            </Card>
        </div>
    );
}

export default FormBanner;
